import { useEffect, useState } from "react";
import { decrypt, encrypt } from "../Utils/cryptoStorage";

export const AddSession = async (key, data) => {
    const encryptedData = await encrypt(data);
    sessionStorage.setItem(key, encryptedData);
}

export const ExtractSession = async(key) => {
    const encryptedData = sessionStorage.getItem(key);
    
    if (!encryptedData) {
        return null;
    }
    
    const data = await decrypt(encryptedData);
    console.log('key', data);
    return data;
    // const [data, setData] = useState(null);
    // useEffect(() => {
    //     const exData = async () => {
    //         const encryptedData = sessionStorage.getItem(key);
    //         const data = await decrypt(encryptedData);
    //         // setData(data)
    //     }
    //     exData();
    // }, [key])
    // return data;
    // console.log(data);
    
}

export const DestroySession = () => {

}